import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false, // Show visible text
      maskAllInputs: true, // Redact user inputs
    }),
  ],
  tracesSampleRate: import.meta.env.MODE === 'development' ? 1.0 : 0.2,
  replaysSessionSampleRate: import.meta.env.MODE === 'development' ? 0.0 : 0.1,
  replaysOnErrorSampleRate: 1.0,
});
